"use client";
import {
  useSelectList
} from "../__chunks/OJBHU3NX.js";
import "../__chunks/O7HGX5PA.js";
import {
  useSelectProviderContext
} from "../__chunks/FXF6FFAU.js";
import "../__chunks/QMBMAMY2.js";
import "../__chunks/3IEDWLST.js";
import "../__chunks/53KINMNA.js";
import "../__chunks/FU7RTSEI.js";
import {
  usePopover
} from "../__chunks/PKN6MQJP.js";
import {
  createDialogComponent
} from "../__chunks/CN7DDZL2.js";
import "../__chunks/GRUZR3XS.js";
import "../__chunks/75IH3TOO.js";
import "../__chunks/SYFUIAXQ.js";
import "../__chunks/P7YNSWBG.js";
import "../__chunks/PKNBS4Q6.js";
import "../__chunks/OTPVYNVT.js";
import "../__chunks/HLTQOHKZ.js";
import "../__chunks/677M2CI3.js";
import "../__chunks/6GXEOXGT.js";
import "../__chunks/3M4W2SZ7.js";
import "../__chunks/MKDDWKFK.js";
import "../__chunks/4SXGPXPS.js";
import "../__chunks/53CQGCDZ.js";
import "../__chunks/DDNAPH23.js";
import "../__chunks/5PY7H3O6.js";
import "../__chunks/5M6RIVE2.js";
import "../__chunks/3HD5ZDMZ.js";
import "../__chunks/FG25KND2.js";
import "../__chunks/AOQQTIBO.js";
import "../__chunks/CZ4GFWYL.js";
import "../__chunks/TNHM3SUC.js";
import "../__chunks/DGQNUP7F.js";
import "../__chunks/URSEQETI.js";
import "../__chunks/J7UNXP2A.js";
import "../__chunks/SJ5YBTFK.js";
import "../__chunks/DYAGAZRT.js";
import "../__chunks/SWN3JYXT.js";
import "../__chunks/2N6FBM3O.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/YIF72NQG.js";
import "../__chunks/X5ETRS5D.js";
import "../__chunks/5UDX7WKK.js";
import "../__chunks/DTNGDFNU.js";
import "../__chunks/OPTPHWV7.js";
import "../__chunks/4ROCFRIN.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/select/select-popover.tsx
var TagName = "div";
var useSelectPopover = createHook(
  function useSelectPopover2(_a) {
    var _b = _a, { store, alwaysVisible } = _b, props = __objRest(_b, ["store", "alwaysVisible"]);
    const context = useSelectProviderContext();
    store = store || context;
    props = useSelectList(__spreadValues({ store, alwaysVisible }, props));
    props = usePopover(__spreadValues({ store, alwaysVisible }, props));
    return props;
  }
);
var SelectPopover = createDialogComponent(
  forwardRef(function SelectPopover2(props) {
    const htmlProps = useSelectPopover(props);
    return createElement(TagName, htmlProps);
  }),
  useSelectProviderContext
);
export {
  SelectPopover,
  useSelectPopover
};
